__turbopack_context__.v({
  "cardSubtitle": "IntelligentInsights-module__ethAea__cardSubtitle",
  "cardTitle": "IntelligentInsights-module__ethAea__cardTitle",
  "cardsTrack": "IntelligentInsights-module__ethAea__cardsTrack",
  "cardsViewport": "IntelligentInsights-module__ethAea__cardsViewport",
  "desktopFrameImage": "IntelligentInsights-module__ethAea__desktopFrameImage" + " " + "IntelligentInsights-module__ethAea__frameImage",
  "frameImage": "IntelligentInsights-module__ethAea__frameImage",
  "framePositioner": "IntelligentInsights-module__ethAea__framePositioner",
  "frameWrapper": "IntelligentInsights-module__ethAea__frameWrapper",
  "insightCard": "IntelligentInsights-module__ethAea__insightCard",
  "mainTitle": "IntelligentInsights-module__ethAea__mainTitle" + " " + __turbopack_context__.i(527070)["heading"],
  "mobileFrameImage": "IntelligentInsights-module__ethAea__mobileFrameImage" + " " + "IntelligentInsights-module__ethAea__frameImage",
  "phoneContainer": "IntelligentInsights-module__ethAea__phoneContainer",
  "section": "IntelligentInsights-module__ethAea__section",
  "sequenceCanvas": "IntelligentInsights-module__ethAea__sequenceCanvas",
  "sequenceWrapper": "IntelligentInsights-module__ethAea__sequenceWrapper",
  "stickyContainer": "IntelligentInsights-module__ethAea__stickyContainer",
  "stickyWrapper": "IntelligentInsights-module__ethAea__stickyWrapper",
});
